<template>
  <div class='amount-of-assets-table-cell' @click='() => { $emit("click") }'>
    {{ item[category.field] }}
  </div>
</template>

<script>
export default {
  name: 'AmountOfAssetsTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.amount-of-assets-table-cell {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: $font-size-2xl;
  font-weight: 600;
  letter-spacing: 0;
  line-height: rem(29);
}
</style>
